import { createStore } from "zustand/vanilla";
import type { KeyValueStorage } from "../adapters";

const KEY = "luckymenu.activeRestaurantId";

export type ActiveRestaurantState = {
	restaurantId: string | null;
	/** True once the stored value has been read. */
	hydrated: boolean;
	choose(restaurantId: string | null): Promise<void>;
};

/**
 * The restaurant the staff member is working in, sent as `x-restaurant-id`.
 * Kept in the platform's storage so it survives restarts.
 */
export function createActiveRestaurantStore(storage: KeyValueStorage) {
	const store = createStore<ActiveRestaurantState>((set) => ({
		restaurantId: null,
		hydrated: false,
		async choose(restaurantId) {
			// A choice made before the stored value arrives wins over it.
			set({ restaurantId, hydrated: true });
			if (restaurantId) await storage.setItem(KEY, restaurantId);
			else await storage.removeItem(KEY);
		},
	}));
	void storage.getItem(KEY).then(
		(restaurantId) => {
			if (!store.getState().hydrated) store.setState({ restaurantId, hydrated: true });
		},
		() => store.setState({ hydrated: true }),
	);
	return store;
}

export type ActiveRestaurantStore = ReturnType<typeof createActiveRestaurantStore>;
